// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gray {
  color: #292727;
}

.login h2 {
  margin-top: 2rem;
  font-size: 1.4rem;
}
.login .disclosure {
  font-size: 1rem;
}
.login .disclosure .terms {
  color: #999;
}
.login .new-registration-disclosure {
  font-size: 1rem;
  font-weight: 500;
  text-align: center;
  color: #515151;
  margin-bottom: 3.7rem;
}
@media (min-resolution: 2dppx) and (min-width: 768px) {
  .login .new-registration-disclosure {
    font-size: 1.1rem;
    margin-bottom: 4.07rem;
  }
}
.login .new-registration-disclosure .new-registration-terms {
  color: #ab3a72;
  font-weight: 600;
}
@media (min-resolution: 2dppx) and (min-width: 768px) {
  .login .new-registration-disclosure .new-registration-terms {
    font-size: 1.1rem;
  }
}
.login.card-body form {
  padding: 0.5rem 0;
}
.login .card-caption {
  font-size: 1.1rem;
}
.login .card-caption small {
  font-size: 1rem;
}
.login .new-registration-caption,
.login .new-registration-caption small {
  font-size: 1.167rem !important;
  text-transform: none;
}
@media (min-resolution: 2dppx) and (min-width: 768px) {
  .login .new-registration-caption,
  .login .new-registration-caption small {
    font-size: 1.2837rem !important;
    margin-bottom: 0.8rem;
  }
}
.login .divider-wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 3.333rem;
}
@media (min-resolution: 2dppx) and (min-width: 768px) {
  .login .divider-wrapper {
    margin-bottom: 3.6663rem;
  }
}
@media (max-width: 767px) {
  .login .divider-wrapper {
    margin-bottom: 2.667rem;
  }
}
.login .divider-wrapper .divider {
  flex: 1;
  height: 0.1rem;
  background-color: #e1e1e1;
  margin: 0 0.2rem;
}
@media (min-resolution: 2dppx) and (min-width: 768px) {
  .login .divider-wrapper .divider {
    height: 0.11rem;
    margin: 0 0.22rem;
  }
}
.login .divider-text {
  padding: 0 0.3rem;
  color: #414141;
  font-size: 1.167rem;
  margin: 0 1.333rem;
  font-weight: 500;
}
@media (min-resolution: 2dppx) and (min-width: 768px) {
  .login .divider-text {
    padding: 0 0.33rem;
    font-size: 1.2837rem;
    margin: 0 1.4663rem;
  }
}
.login .btn-artful {
  margin-top: 1rem;
  background-color: #ab3a72;
  color: white;
  border-radius: 0;
  border: 0.1rem solid #ab3a72;
  padding: 0.5em 0.6em;
}
.login .btn-artful:hover {
  background-color: white;
  color: black;
  border: 0.1rem solid black;
}
.login .top-checkbox {
  padding: 0rem 0.2rem 0.7rem;
}
.login .bottom-checkbox {
  padding: 0 0.2rem 0.6rem;
}
.login .google-button-add-account {
  padding: 0.2rem 4rem;
  border: none;
  background-size: contain;
}
.login .add-account-spinner {
  padding-left: 12rem;
}
.login .registration-checkbox-text {
  font-size: 1.2rem;
}
.login .text-error {
  color: red;
}
.login .login-link {
  text-decoration: underline;
  padding-left: 0.5rem;
  border: none;
  background: transparent;
}
.login .new-registration-login-link {
  text-decoration: none;
  font-weight: 600;
  color: #ab3a72;
  padding-left: 0.667rem;
}
@media (min-resolution: 2dppx) and (min-width: 768px) {
  .login .new-registration-login-link {
    padding-left: 0.7337rem;
  }
}
.login .google-button-text {
  color: #515151;
  font-size: 1.5rem;
  font-weight: 500;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
}
@media (min-resolution: 2dppx) and (min-width: 768px) {
  .login .google-button-text {
    font-size: 1.65rem;
  }
}
.login .google-button {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  height: 4.583rem;
  border: 0.1rem solid #888888;
  margin: 0 0.1rem 1rem;
}
@media (min-resolution: 2dppx) and (min-width: 768px) {
  .login .google-button {
    height: 5.0413rem;
    border-width: 0.11rem;
    margin: 0 0.11rem 1.1rem;
  }
}
.login .google-button:hover {
  cursor: pointer;
  background: rgba(238, 236, 236, 0.478);
}
.login .google-button-disabled {
  color: #a0a5aa;
  background: #f7f7f7;
  border-color: #ddd;
}
@media (min-resolution: 2dppx) and (min-width: 768px) {
  .login .google-button-disabled {
    border-width: 0.11rem;
  }
}
.login .google-logo {
  height: 2.8rem;
  margin-right: 1.333rem;
}
@media (min-resolution: 2dppx) and (min-width: 768px) {
  .login .google-logo {
    height: 3.08rem;
    margin-right: 1.4663rem;
  }
}
.login .react-apple-signin-auth-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: calc(100% - 0.2rem);
  height: 4.583rem;
  position: relative;
  border-radius: 0;
  font-size: 1.5rem;
  font-weight: 500;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  color: #515151;
  margin: 0.1rem 0.1rem 3.333rem;
  border: 0.1rem solid #888888;
}
.login .react-apple-signin-auth-btn svg {
  margin-right: 1.317rem;
  height: 3.4rem !important;
  width: 3.4rem !important;
  scale: 1.5;
}
.login .react-apple-signin-auth-btn svg rect {
  fill: transparent;
}
@media (min-resolution: 2dppx) and (min-width: 768px) {
  .login .react-apple-signin-auth-btn svg {
    margin-right: 1.445rem;
    height: 3.64rem !important;
    width: 3.64rem !important;
    scale: 1.65;
  }
}
.login .react-apple-signin-auth-btn:hover {
  cursor: pointer;
  background: rgba(238, 236, 236, 0.478);
}
.login .react-apple-signin-auth-btn:hover svg g path {
  fill: #000 !important;
}
.login .react-apple-signin-auth-btn[disabled] {
  color: #a0a5aa;
  background: #f7f7f7;
  border-color: #ddd;
}
.login .react-apple-signin-auth-btn[disabled] svg g path {
  fill: #a0a5aa !important;
}
@media (min-resolution: 2dppx) and (min-width: 768px) {
  .login .react-apple-signin-auth-btn {
    height: 5.0413rem;
    font-size: 1.65rem;
    border-width: 0.11rem;
    margin-bottom: 4rem;
  }
}
@media (max-width: 767px) {
  .login .react-apple-signin-auth-btn {
    margin-bottom: 2.667rem;
  }
}

.new-registration-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2.083rem;
  margin-top: 0.583rem;
}
@media (min-resolution: 2dppx) and (min-width: 768px) {
  .new-registration-container {
    gap: 2.2913rem;
    margin-top: 0.6383rem;
  }
}
@media (min-width: 767px) and (max-width: 1023px) {
  .new-registration-container {
    display: grid;
    grid-template-rows: 1fr auto 1fr;
    grid-template-columns: 1fr 1fr;
  }
}
@media (min-width: 767px) and (max-width: 1024px) {
  .new-registration-container {
    margin-right: 2.2913rem;
    margin-left: 2.2913rem;
  }
}
@media (max-width: 767px) {
  .new-registration-container {
    flex-direction: column;
    margin-top: 0;
    justify-content: flex-start;
    gap: 0;
    width: 100%;
  }
}
.new-registration-container .new-registration-image-container {
  flex-shrink: 0;
  position: relative;
  width: 42.875rem;
  box-shadow: 0 1rem 2rem rgba(0, 0, 0, 0.19), 0 0.6rem 0.6rem rgba(0, 0, 0, 0.23);
}
@media (min-width: 767px) and (max-width: 1023px) {
  .new-registration-container .new-registration-image-container .image-carousel {
    box-shadow: 0 1rem 2rem rgba(0, 0, 0, 0.19), 0 0.6rem 0.6rem rgba(0, 0, 0, 0.23);
  }
}
@media (max-width: 767px) {
  .new-registration-container .new-registration-image-container .carousel-image {
    width: 100%;
  }
}
@media (min-width: 767px) and (max-width: 1023px) {
  .new-registration-container .new-registration-image-container {
    grid-row: 2;
    grid-column: 1;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    width: unset;
    height: 100%;
    box-shadow: none;
  }
}
@media (min-resolution: 2dppx) and (min-width: 1024px) {
  .new-registration-container .new-registration-image-container {
    width: 47.1625rem;
  }
}
@media (max-width: 767px) {
  .new-registration-container .new-registration-image-container {
    width: 100%;
  }
}
@media (max-width: 767px) {
  .new-registration-container .new-registration-image-container .review-parent {
    position: absolute;
    top: 0px;
    height: 46.5dvh;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}
.new-registration-container .new-registration-image-container .review {
  position: absolute;
  top: 2%;
  left: 50%;
  transform: translateX(-50%);
  height: auto;
  width: 38.917rem;
  background-color: rgb(255, 255, 255);
  padding: 2rem;
  text-align: left;
  z-index: 2;
  box-shadow: 0 1rem 2rem rgba(0, 0, 0, 0.19), 0 0.6rem 0.6rem rgba(0, 0, 0, 0.23);
}
@media (min-resolution: 2dppx) and (min-width: 768px) {
  .new-registration-container .new-registration-image-container .review {
    width: 42.8087rem;
    padding: 2.2rem;
  }
}
@media (min-width: 767px) and (max-width: 1023px) {
  .new-registration-container .new-registration-image-container .review {
    width: 90%;
    top: 0%;
  }
}
@media (max-width: 767px) {
  .new-registration-container .new-registration-image-container .review {
    position: absolute;
    height: -moz-max-content;
    height: max-content;
    width: 90%;
    padding: 1.333rem;
    text-align: center;
    transform: none;
    top: 6%;
    left: unset;
  }
}
.new-registration-container .new-registration-image-container .review p {
  font-size: 1.3937rem;
  color: rgb(81, 81, 81);
}
@media (max-width: 767px) {
  .new-registration-container .new-registration-image-container .review p {
    font-size: 1.25rem;
  }
}
.new-registration-container .new-registration-image-container .review-review {
  font-weight: 500;
  margin-bottom: 1.667rem;
}
@media (min-resolution: 2dppx) and (min-width: 768px) {
  .new-registration-container .new-registration-image-container .review-review {
    margin-bottom: 1.8337rem;
  }
}
@media (max-width: 767px) {
  .new-registration-container .new-registration-image-container .review-review {
    margin-bottom: 4.583rem;
    padding-bottom: 0.583rem;
  }
}
.new-registration-container .new-registration-image-container .review-name {
  font-weight: 700;
  margin-bottom: 0rem;
}
@media (min-resolution: 2dppx) and (min-width: 768px) {
  .new-registration-container .new-registration-image-container .review-name {
    margin-bottom: 0rem;
  }
}
@media (max-width: 767px) {
  .new-registration-container .new-registration-image-container .review-name {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    margin-bottom: 3rem;
  }
}
.new-registration-container .new-registration-image-container .review-quotation-mark {
  height: 2rem;
  margin-bottom: 0.667rem;
}
@media (min-resolution: 2dppx) and (min-width: 768px) {
  .new-registration-container .new-registration-image-container .review-quotation-mark {
    height: 2.2rem;
    margin-bottom: 0.7337rem;
  }
}
@media (max-width: 767px) {
  .new-registration-container .new-registration-image-container .review-quotation-mark {
    display: none;
  }
}
.new-registration-container .new-registration-image-container .dots-container {
  display: flex;
  justify-content: end;
  margin-top: 0.333rem;
}
@media (min-resolution: 2dppx) and (min-width: 768px) {
  .new-registration-container .new-registration-image-container .dots-container {
    margin-top: 0.3663rem;
  }
}
@media (max-width: 767px) {
  .new-registration-container .new-registration-image-container .dots-container {
    justify-content: center;
    margin-top: 1rem;
    margin-bottom: 1.333rem;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
  }
}
.new-registration-container .new-registration-image-container .dot {
  height: 0.667rem;
  width: 0.667rem;
  background-color: rgba(232, 232, 232, 0.91);
  border-radius: 50%;
  margin: 0 0.167rem;
  transition: background-color 0.3s ease;
}
@media (min-resolution: 2dppx) and (min-width: 768px) {
  .new-registration-container .new-registration-image-container .dot {
    height: 0.7337rem;
    width: 0.7337rem;
    margin: 0 0.1837rem;
  }
}
.new-registration-container .new-registration-image-container .dot.active {
  background-color: #ab3a72;
}
@media (min-width: 767px) and (max-width: 1023px) {
  .new-registration-container .new-registration-card-container {
    grid-row: 2;
    grid-column: 2;
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
  }
}
@media (max-width: 767px) {
  .new-registration-container .new-registration-card-container {
    width: 100%;
    z-index: 3;
    position: absolute;
    top: 51%;
  }
}
@media (max-width: 344px) and (min-height: 882px) {
  .new-registration-container .new-registration-card-container {
    top: 47%;
  }
}
.new-registration-container .new-registration-card-container .card {
  width: 42.917rem;
  height: auto;
  padding: 3.667rem 2.667rem 2rem 2.667rem;
  border-radius: 0;
}
@media (min-width: 767px) and (max-width: 1023px) {
  .new-registration-container .new-registration-card-container .card {
    width: unset;
    height: 100%;
  }
}
@media (min-resolution: 2dppx) and (min-width: 1024px) {
  .new-registration-container .new-registration-card-container .card {
    width: 47.2087rem;
    padding: 4.0337rem 2.9337rem 2.2rem 2.9337rem;
  }
}
@media (max-width: 767px) {
  .new-registration-container .new-registration-card-container .card {
    width: 100%;
    min-width: 32.5rem;
    padding: 3.2rem 2.133rem 3.2rem 2.133rem;
  }
}
.new-registration-container .new-registration-card-container .card h2 {
  margin-top: 0;
  font-size: 1.667rem;
  color: #515151;
  margin-bottom: 3.333rem !important;
}
@media (min-resolution: 2dppx) and (min-width: 768px) {
  .new-registration-container .new-registration-card-container .card h2 {
    font-size: 1.8337rem;
    margin-bottom: 3.6663rem !important;
  }
}
@media (max-width: 767px) {
  .new-registration-container .new-registration-card-container .card h2 {
    margin-bottom: 3.2rem !important;
  }
}
.new-registration-container .new-registration-card-container .card .referral-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 3.333rem !important;
}
@media (min-resolution: 2dppx) and (min-width: 768px) {
  .new-registration-container .new-registration-card-container .card .referral-container {
    margin-bottom: 3.6663rem !important;
  }
}
@media (max-width: 767px) {
  .new-registration-container .new-registration-card-container .card .referral-container {
    margin-bottom: 3.2rem !important;
  }
}
.new-registration-container .new-registration-card-container .card .referral-text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  font-size: 1.25rem;
  font-weight: 500;
  color: rgb(81, 81, 81);
  margin-right: 1.333rem;
}
@media (min-resolution: 2dppx) and (min-width: 768px) {
  .new-registration-container .new-registration-card-container .card .referral-text {
    font-size: 1.375rem;
    margin-right: 1.4663rem;
  }
}
.new-registration-container .new-registration-card-container .card .referral-text p {
  margin: 0;
}
.new-registration-container .new-registration-card-container .card .referral-code {
  text-align: center;
  margin-top: 3.333rem;
  margin-bottom: 1.333rem;
  color: #8e8e8e;
  font-size: 1.167rem;
}
@media (min-resolution: 2dppx) and (min-width: 768px) {
  .new-registration-container .new-registration-card-container .card .referral-code {
    font-size: 1.2837rem;
    margin-top: 3.6663rem;
    margin-bottom: 1.4663rem;
  }
}
.new-registration-container .new-registration-card-container .card .new-registration-form-block {
  margin-bottom: 1rem;
}
@media (min-resolution: 2dppx) and (min-width: 768px) {
  .new-registration-container .new-registration-card-container .card .new-registration-form-block {
    margin-bottom: 1.1rem;
  }
}
@media (min-width: 767px) and (max-width: 1023px) {
  .new-registration-container .new-registration-card-container .card .new-registration-form-block .new-registration-input-row {
    display: flex;
    gap: 2rem;
    justify-content: space-between;
  }
}
@media (min-width: 767px) and (max-width: 1023px) {
  .new-registration-container .new-registration-card-container .card .new-registration-form-block .new-registration-input-row .form-group {
    flex: 1;
  }
}
.new-registration-container .new-registration-card-container .card .form-group {
  margin-bottom: 1.333rem;
}
@media (min-resolution: 2dppx) and (min-width: 768px) {
  .new-registration-container .new-registration-card-container .card .form-group {
    margin-bottom: 1.4663rem;
  }
}
.new-registration-container .new-registration-card-container .card .form-group:has(.new-registration-referral) {
  margin-bottom: 0 !important;
}
.new-registration-container .new-registration-card-container .card .new-registration-referral {
  width: 9.417rem;
  height: 3.333rem;
  font-size: 1.25rem;
  font-weight: 500;
  color: rgba(136, 136, 136, 0.5);
  text-align: center;
  border: 1px solid rgba(136, 136, 136, 0.5) !important;
  border-radius: 0;
  margin-bottom: 0 !important;
}
@media (min-resolution: 2dppx) and (min-width: 768px) {
  .new-registration-container .new-registration-card-container .card .new-registration-referral {
    width: 10.3587rem;
    height: 3.6663rem;
    font-size: 1.375rem;
    border: 1.1px solid rgba(136, 136, 136, 0.5) !important;
  }
}
.new-registration-container .new-registration-card-container .card .new-registration-field {
  padding-left: 0rem;
  padding-bottom: 1.667rem;
  padding-top: 0.667rem;
  font-size: 1.333rem;
  font-weight: 500;
  color: #8e8e8e;
  border-bottom: 0.083rem solid #888888 !important;
}
@media (min-resolution: 2dppx) and (min-width: 768px) {
  .new-registration-container .new-registration-card-container .card .new-registration-field {
    font-size: 1.4663rem;
    padding-bottom: 1.8337rem;
    padding-top: 0.7337rem;
  }
}

.new-registration-button {
  margin-top: 2rem !important;
  font-size: 1.333rem !important;
  font-weight: 500 !important;
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
  display: block;
  width: 100%;
}
@media (min-resolution: 2dppx) and (min-width: 768px) {
  .new-registration-button {
    font-size: 1.4663rem !important;
    margin-top: 2.2rem !important;
    padding-top: 1.1rem !important;
    padding-bottom: 1.1rem !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/Styles/Colors.scss","webpack://./src/Components/Pages/Register/Register.scss"],"names":[],"mappings":"AAsCA;EACE,cArCU;ACAZ;;AAEE;EACE,gBAAA;EACA,iBAAA;AACJ;AAEE;EAEE,eAAA;AADJ;AAEI;EACE,WAAA;AAAN;AAME;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,qBAAA;AAJJ;AAKI;EANF;IAOI,iBAAA;IACA,sBAAA;EAFJ;AACF;AAGI;EACE,cDPI;ECQJ,gBAAA;AADN;AAEM;EAHF;IAII,iBAAA;EACN;AACF;AAGE;EACE,iBAAA;AADJ;AAIE;EACE,iBAAA;AAFJ;AAGI;EACE,eAAA;AADN;AAIE;;EAEE,8BAAA;EACA,oBAAA;AAFJ;AAGI;EAJF;;IAKI,+BAAA;IACA,qBAAA;EACJ;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AACJ;AAAI;EAJF;IAKI,wBAAA;EAGJ;AACF;AAFI;EAPF;IAQI,uBAAA;EAKJ;AACF;AAJI;EACE,OAAA;EACA,cAAA;EACA,yBAAA;EACA,gBAAA;AAMN;AALM;EALF;IAMI,eAAA;IACA,iBAAA;EAQN;AACF;AALE;EACE,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AAOJ;AANI;EANF;IAOI,kBAAA;IACA,oBAAA;IACA,mBAAA;EASJ;AACF;AAPE;EACE,gBAAA;EACA,yBDrEM;ECsEN,YAAA;EACA,gBAAA;EACA,4BAAA;EACA,oBAAA;AASJ;AAPI;EACE,uBAAA;EACA,YAAA;EACA,0BAAA;AASN;AANE;EACE,2BAAA;AAQJ;AANE;EACE,wBAAA;AAQJ;AANE;EACE,oBAAA;EACA,YAAA;EACA,wBAAA;AAQJ;AANE;EACE,mBAAA;AAQJ;AANE;EACE,iBAAA;AAQJ;AANE;EACE,UDxFW;ACgGf;AANE;EACE,0BAAA;EACA,oBAAA;EACA,YAAA;EACA,uBAAA;AAQJ;AANE;EACE,qBAAA;EACA,gBAAA;EACA,cD9GM;EC+GN,sBAAA;AAQJ;AAPI;EALF;IAMI,uBAAA;EAUJ;AACF;AARE;EACE,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,mJAAA;AAUJ;AARI;EANF;IAOI,kBAAA;EAWJ;AACF;AATE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4BAAA;EACA,qBAAA;AAWJ;AAVI;EARF;IASI,iBAAA;IACA,qBAAA;IACA,wBAAA;EAaJ;AACF;AAXI;EACE,eAAA;EACA,sCAAA;AAaN;AAVE;EACE,cAAA;EACA,mBAAA;EACA,kBAAA;AAYJ;AAXI;EAJF;IAKI,qBAAA;EAcJ;AACF;AAZE;EACE,cAAA;EACA,sBAAA;AAcJ;AAbI;EAHF;IAII,eAAA;IACA,uBAAA;EAgBJ;AACF;AAdE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,0BAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mJAAA;EAEA,cAAA;EACA,8BAAA;EACA,4BAAA;AAeJ;AAdI;EACE,sBAAA;EACA,yBAAA;EACA,wBAAA;EACA,UAAA;AAgBN;AAfM;EACE,iBAAA;AAiBR;AAfM;EARF;IASI,sBAAA;IACA,0BAAA;IACA,yBAAA;IACA,WAAA;EAkBN;AACF;AAfI;EACE,eAAA;EACA,sCAAA;AAiBN;AAhBM;EACE,qBAAA;AAkBR;AAdI;EACE,cAAA;EACA,mBAAA;EACA,kBAAA;AAgBN;AAdM;EACE,wBAAA;AAgBR;AAbI;EAhDF;IAiDI,iBAAA;IACA,kBAAA;IACA,qBAAA;IACA,mBAAA;EAgBJ;AACF;AAfI;EAtDF;IAuDI,uBAAA;EAkBJ;AACF;;AAdA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,oBAAA;AAiBF;AAhBE;EANF;IAOI,cAAA;IACA,qBAAA;EAmBF;AACF;AAlBE;EAVF;IAWI,aAAA;IACA,gCAAA;IACA,8BAAA;EAqBF;AACF;AApBE;EAfF;IAgBI,uBAAA;IACA,sBAAA;EAuBF;AACF;AAtBE;EAnBF;IAoBI,sBAAA;IACA,aAAA;IACA,2BAAA;IACA,MAAA;IACA,WAAA;EAyBF;AACF;AAvBE;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EA2BA,gFAAA;AADJ;AAxBM;EADF;IAEI,gFAAA;EA2BN;AACF;AAxBM;EADF;IAEI,WAAA;EA2BN;AACF;AAzBI;EAdF;IAeI,WAAA;IACA,cAAA;IACA,aAAA;IACA,sBAAA;IACA,yBAAA;IACA,YAAA;IACA,YAAA;IACA,gBAAA;EA4BJ;AACF;AA3BI;EAxBF;IAyBI,iBAAA;EA8BJ;AACF;AA7BI;EA3BF;IA4BI,WAAA;EAgCJ;AACF;AA7BM;EADF;IAEI,kBAAA;IACA,QAAA;IACA,eAAA;IACA,WAAA;IACA,aAAA;IACA,sBAAA;IACA,uBAAA;IACA,mBAAA;EAgCN;AACF;AA9BI;EACE,kBAAA;EACA,OAAA;EACA,SAAA;EACA,2BAAA;EACA,YAAA;EACA,gBAAA;EACA,oCAAA;EACA,aAAA;EACA,gBAAA;EACA,UAAA;EAmBA,gFAAA;AAcN;AAhCM;EAXF;IAYI,iBAAA;IACA,eAAA;EAmCN;AACF;AAlCM;EAfF;IAgBI,UAAA;IACA,OAAA;EAqCN;AACF;AApCM;EAnBF;IAoBI,kBAAA;IACA,wBAAA;IAAA,mBAAA;IACA,UAAA;IACA,iBAAA;IACA,kBAAA;IACA,eAAA;IACA,OAAA;IACA,WAAA;EAuCN;AACF;AAnCI;EACE,oBAAA;EACA,sBAAA;AAqCN;AApCM;EAHF;IAII,kBAAA;EAuCN;AACF;AApCI;EACE,gBAAA;EACA,uBAAA;AAsCN;AArCM;EAHF;IAII,wBAAA;EAwCN;AACF;AAvCM;EANF;IAOI,uBAAA;IACA,wBAAA;EA0CN;AACF;AAvCI;EACE,gBAAA;EACA,mBAAA;AAyCN;AAxCM;EAHF;IAII,mBAAA;EA2CN;AACF;AA1CM;EANF;IAOI,kBAAA;IACA,SAAA;IACA,SAAA;IACA,2BAAA;IACA,mBAAA;EA6CN;AACF;AA3CI;EACE,YAAA;EACA,uBAAA;AA6CN;AA5CM;EAHF;IAII,cAAA;IACA,wBAAA;EA+CN;AACF;AA9CM;EAPF;IAQI,aAAA;EAiDN;AACF;AA9CI;EACE,aAAA;EACA,oBAAA;EACA,oBAAA;AAgDN;AA/CM;EAJF;IAKI,qBAAA;EAkDN;AACF;AAjDM;EAPF;IAQI,uBAAA;IACA,gBAAA;IACA,uBAAA;IACA,kBAAA;IACA,SAAA;IACA,SAAA;IACA,2BAAA;EAoDN;AACF;AAjDI;EACE,gBAAA;EACA,eAAA;EACA,2CAAA;EACA,kBAAA;EACA,kBAAA;EACA,sCAAA;AAmDN;AAlDM;EAPF;IAQI,iBAAA;IACA,gBAAA;IACA,mBAAA;EAqDN;AACF;AAlDI;EACE,yBDlZI;ACscV;AA/CI;EADF;IAEI,WAAA;IACA,cAAA;IACA,aAAA;IACA,sBAAA;IACA,uBAAA;IACA,YAAA;EAkDJ;AACF;AAjDI;EATF;IAUI,WAAA;IACA,UAAA;IACA,kBAAA;IACA,QAAA;EAoDJ;AACF;AAnDI;EAfF;IAgBI,QAAA;EAsDJ;AACF;AArDI;EACE,gBAAA;EACA,YAAA;EACA,wCAAA;EACA,gBAAA;AAuDN;AAtDM;EALF;IAMI,YAAA;IACA,YAAA;EAyDN;AACF;AAxDM;EATF;IAUI,iBAAA;IACA,6CAAA;EA2DN;AACF;AA1DM;EAbF;IAcI,WAAA;IACA,kBAAA;IACA,wCAAA;EA6DN;AACF;AA5DM;EACE,aAAA;EACA,mBAAA;EACA,cAAA;EACA,kCAAA;AA8DR;AA7DQ;EALF;IAMI,oBAAA;IACA,mCAAA;EAgER;AACF;AA/DQ;EATF;IAUI,gCAAA;EAkER;AACF;AAhEM;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kCAAA;AAkER;AAjEQ;EALF;IAMI,mCAAA;EAoER;AACF;AAnEQ;EARF;IASI,gCAAA;EAsER;AACF;AApEM;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,sBAAA;AAsER;AArEQ;EARF;IASI,mBAAA;IACA,uBAAA;EAwER;AACF;AAtEM;EACE,SAAA;AAwER;AAtEM;EACE,kBAAA;EACA,oBAAA;EACA,uBAAA;EACA,cAAA;EACA,mBAAA;AAwER;AAvEQ;EANF;IAOI,oBAAA;IACA,qBAAA;IACA,wBAAA;EA0ER;AACF;AAxEM;EACE,mBAAA;AA0ER;AAzEQ;EAFF;IAGI,qBAAA;EA4ER;AACF;AA1EU;EADF;IAEI,aAAA;IACA,SAAA;IACA,8BAAA;EA6EV;AACF;AA3EY;EADF;IAEI,OAAA;EA8EZ;AACF;AA1EM;EACE,uBAAA;AA4ER;AA3EQ;EAFF;IAGI,wBAAA;EA8ER;AACF;AA5EM;EACE,2BAAA;AA8ER;AA5EM;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,+BAAA;EACA,kBAAA;EACA,qDAAA;EACA,gBAAA;EACA,2BAAA;AA8ER;AA7EQ;EAVF;IAWI,iBAAA;IACA,iBAAA;IACA,mBAAA;IACA,uDAAA;EAgFR;AACF;AA9EM;EACE,kBAAA;EACA,wBAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,gDAAA;AAgFR;AA/EQ;EARF;IASI,oBAAA;IACA,yBAAA;IACA,sBAAA;EAkFR;AACF;;AA5EA;EACE,2BAAA;EACA,8BAAA;EACA,2BAAA;EACA,4BAAA;EACA,+BAAA;EACA,cAAA;EACA,WAAA;AA+EF;AA9EE;EARF;IASI,+BAAA;IACA,6BAAA;IACA,8BAAA;IACA,iCAAA;EAiFF;AACF","sourcesContent":["// Define colors here to use across the site\n\n$textColor: #292727;\n$darkTextColor: #696969;\n$lightTextColor: #cacacb;\n$black: black;\n$borderColor: #c0c0c0;\n$gridBorderColor: #ddd;\n$hoverColor: #b8b8b8;\n$shadow: #9c9c9c;\n$gray: #efefef;\n$darkGray: #515554;\n$backgroundColor: #ffffff;\n$backgroundRight: #ffffff;\n$backgroundLeft: #e9e9e9;\n$success: #18b100;\n$headingsGray: #333333;\n$camelGold: #d0ad4d;\n$gold: #dabc64;\n$iconColor: #9c9c9c;\n$navIcon: #4d4d4d;\n$navIconActive: #dabc64;\n$iconColorActive: #dabc64;\n$magenta: #ab3a72;\n$habitPrimary: rgb(51, 51, 51);\n$habitBorder: rgb(208, 213, 221);\n$habitActionText: rgb(86, 86, 86);\n$habitActionIcon: #565656;\n\n// Brands\n$brand-primary: #3097d1;\n$brand-info: #8eb4cb;\n$brand-success: #2ab27b;\n$brand-warning: #cbb956;\n$brand-danger: red;\n\n$orange: #f5a000;\n\n.gray {\n  color: $textColor;\n}\n\n$input-color: #555;\n\n$headingColor: #999;\n$dayHeadingColor: #555;\n$undoBackground: #bdbdbd;\n","@import '~/Styles/Colors';\n@import '~/Styles/Variables';\n\n.login {\n  h2 {\n    margin-top: 2rem;\n    font-size: 1.4rem;\n  }\n\n  .disclosure {\n    // margin-top: 2rem;\n    font-size: 1rem;\n    .terms {\n      color: #999;\n      // margin-left: 0.2rem;\n    }\n    // margin-bottom: 1rem;\n  }\n\n  .new-registration-disclosure {\n    font-size: 1rem;\n    font-weight: 500;\n    text-align: center;\n    color: #515151;\n    margin-bottom: 3.7rem;\n    @media (min-resolution: 2dppx) and (min-width: $tablet) {\n      font-size: 1.1rem; //scale-up by 1.1\n      margin-bottom: 4.07rem;\n    }\n    .new-registration-terms {\n      color: $magenta;\n      font-weight: 600;\n      @media (min-resolution: 2dppx) and (min-width: $tablet) {\n        font-size: 1.1rem;\n      }\n    }\n  }\n\n  &.card-body form {\n    padding: 0.5rem 0;\n  }\n\n  .card-caption {\n    font-size: 1.1rem;\n    small {\n      font-size: 1rem;\n    }\n  }\n  .new-registration-caption,\n  .new-registration-caption small {\n    font-size: 1.167rem !important;\n    text-transform: none;\n    @media (min-resolution: 2dppx) and (min-width: $tablet) {\n      font-size: 1.2837rem !important;\n      margin-bottom: 0.8rem;\n    }\n  }\n  .divider-wrapper {\n    display: flex;\n    align-items: center;\n    margin-bottom: 3.333rem;\n    @media (min-resolution: 2dppx) and (min-width: $tablet) {\n      margin-bottom: 3.6663rem;\n    }\n    @media (max-width: 767px) {\n      margin-bottom: 2.667rem;\n    }\n    .divider {\n      flex: 1;\n      height: 0.1rem;\n      background-color: #e1e1e1;\n      margin: 0 0.2rem;\n      @media (min-resolution: 2dppx) and (min-width: $tablet) {\n        height: 0.11rem;\n        margin: 0 0.22rem;\n      }\n    }\n  }\n  .divider-text {\n    padding: 0 0.3rem;\n    color: #414141;\n    font-size: 1.167rem;\n    margin: 0 1.333rem;\n    font-weight: 500;\n    @media (min-resolution: 2dppx) and (min-width: $tablet) {\n      padding: 0 0.33rem;\n      font-size: 1.2837rem;\n      margin: 0 1.4663rem;\n    }\n  }\n  .btn-artful {\n    margin-top: 1rem;\n    background-color: $magenta;\n    color: white;\n    border-radius: 0;\n    border: 0.1rem solid $magenta;\n    padding: 0.5em 0.6em;\n\n    &:hover {\n      background-color: white;\n      color: black;\n      border: 0.1rem solid black;\n    }\n  }\n  .top-checkbox {\n    padding: 0rem 0.2rem 0.7rem;\n  }\n  .bottom-checkbox {\n    padding: 0 0.2rem 0.6rem;\n  }\n  .google-button-add-account {\n    padding: 0.2rem 4rem;\n    border: none;\n    background-size: contain;\n  }\n  .add-account-spinner {\n    padding-left: 12rem;\n  }\n  .registration-checkbox-text {\n    font-size: 1.2rem;\n  }\n  .text-error {\n    color: $brand-danger;\n  }\n  .login-link {\n    text-decoration: underline;\n    padding-left: 0.5rem;\n    border: none;\n    background: transparent;\n  }\n  .new-registration-login-link {\n    text-decoration: none;\n    font-weight: 600;\n    color: $magenta;\n    padding-left: 0.667rem;\n    @media (min-resolution: 2dppx) and (min-width: $tablet) {\n      padding-left: 0.7337rem;\n    }\n  }\n  .google-button-text {\n    color: #515151;\n    font-size: 1.5rem;\n    font-weight: 500;\n    font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu,\n      Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n    @media (min-resolution: 2dppx) and (min-width: $tablet) {\n      font-size: 1.65rem;\n    }\n  }\n  .google-button {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n    height: 4.583rem;\n    border: 0.1rem solid #888888;\n    margin: 0 0.1rem 1rem;\n    @media (min-resolution: 2dppx) and (min-width: $tablet) {\n      height: 5.0413rem;\n      border-width: 0.11rem;\n      margin: 0 0.11rem 1.1rem;\n    }\n\n    &:hover {\n      cursor: pointer;\n      background: rgba(238, 236, 236, 0.478);\n    }\n  }\n  .google-button-disabled {\n    color: #a0a5aa;\n    background: #f7f7f7;\n    border-color: #ddd;\n    @media (min-resolution: 2dppx) and (min-width: $tablet) {\n      border-width: 0.11rem;\n    }\n  }\n  .google-logo {\n    height: 2.8rem;\n    margin-right: 1.333rem;\n    @media (min-resolution: 2dppx) and (min-width: $tablet) {\n      height: 3.08rem;\n      margin-right: 1.4663rem;\n    }\n  }\n  .react-apple-signin-auth-btn {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: calc(100% - 0.2rem);\n    height: 4.583rem;\n    position: relative;\n    border-radius: 0;\n    font-size: 1.5rem;\n    font-weight: 500;\n    font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu,\n      Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n    color: #515151;\n    margin: 0.1rem 0.1rem 3.333rem;\n    border: 0.1rem solid #888888;\n    svg {\n      margin-right: 1.317rem;\n      height: 3.4rem !important;\n      width: 3.4rem !important;\n      scale: 1.5;\n      rect {\n        fill: transparent;\n      }\n      @media (min-resolution: 2dppx) and (min-width: $tablet) {\n        margin-right: 1.445rem;\n        height: 3.64rem !important;\n        width: 3.64rem !important;\n        scale: 1.65;\n      }\n    }\n\n    &:hover {\n      cursor: pointer;\n      background: rgba(238, 236, 236, 0.478);\n      svg g path {\n        fill: #000 !important;\n      }\n    }\n\n    &[disabled] {\n      color: #a0a5aa;\n      background: #f7f7f7;\n      border-color: #ddd;\n\n      svg g path {\n        fill: #a0a5aa !important;\n      }\n    }\n    @media (min-resolution: 2dppx) and (min-width: $tablet) {\n      height: 5.0413rem;\n      font-size: 1.65rem;\n      border-width: 0.11rem;\n      margin-bottom: 4rem;\n    }\n    @media (max-width: 767px) {\n      margin-bottom: 2.667rem;\n    }\n  }\n}\n\n.new-registration-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 2.083rem;\n  margin-top: 0.583rem;\n  @media (min-resolution: 2dppx) and (min-width: $tablet) {\n    gap: 2.2913rem;\n    margin-top: 0.6383rem;\n  }\n  @media (min-width: 767px) and (max-width: 1023px) {\n    display: grid;\n    grid-template-rows: 1fr auto 1fr;\n    grid-template-columns: 1fr 1fr;\n  }\n  @media (min-width: 767px) and (max-width: $laptop) {\n    margin-right: 2.2913rem;\n    margin-left: 2.2913rem;\n  }\n  @media (max-width: 767px) {\n    flex-direction: column;\n    margin-top: 0;\n    justify-content: flex-start;\n    gap: 0;\n    width: 100%;\n  }\n\n  .new-registration-image-container {\n    flex-shrink: 0;\n    position: relative;\n    width: 42.875rem;\n    .image-carousel {\n      @media (min-width: 767px) and (max-width: 1023px) {\n        box-shadow: 0 1rem 2rem rgba(0, 0, 0, 0.19), 0 0.6rem 0.6rem rgba(0, 0, 0, 0.23);\n      }\n    }\n    .carousel-image {\n      @media (max-width: 767px) {\n        width: 100%;\n      }\n    }\n    @media (min-width: 767px) and (max-width: 1023px) {\n      grid-row: 2;\n      grid-column: 1;\n      display: flex;\n      flex-direction: column;\n      justify-content: flex-end;\n      width: unset;\n      height: 100%;\n      box-shadow: none;\n    }\n    @media (min-resolution: 2dppx) and (min-width: $laptop) {\n      width: 47.1625rem;\n    }\n    @media (max-width: 767px) {\n      width: 100%;\n    }\n    box-shadow: 0 1rem 2rem rgba(0, 0, 0, 0.19), 0 0.6rem 0.6rem rgba(0, 0, 0, 0.23);\n    .review-parent {\n      @media (max-width: 767px) {\n        position: absolute;\n        top: 0px;\n        height: 46.5dvh;\n        width: 100%;\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n      }\n    }\n    .review {\n      position: absolute;\n      top: 2%;\n      left: 50%;\n      transform: translateX(-50%);\n      height: auto;\n      width: 38.917rem;\n      background-color: rgba(255, 255, 255, 1);\n      padding: 2rem;\n      text-align: left;\n      z-index: 2;\n      @media (min-resolution: 2dppx) and (min-width: $tablet) {\n        width: 42.8087rem;\n        padding: 2.2rem;\n      }\n      @media (min-width: 767px) and (max-width: 1023px) {\n        width: 90%;\n        top: 0%;\n      }\n      @media (max-width: 767px) {\n        position: absolute;\n        height: max-content;\n        width: 90%;\n        padding: 1.333rem;\n        text-align: center;\n        transform: none;\n        top: 6%;\n        left: unset;\n      }\n      box-shadow: 0 1rem 2rem rgba(0, 0, 0, 0.19), 0 0.6rem 0.6rem rgba(0, 0, 0, 0.23);\n    }\n\n    .review p {\n      font-size: 1.3937rem;\n      color: rgba(81, 81, 81, 1);\n      @media (max-width: 767px) {\n        font-size: 1.25rem;\n      }\n    }\n\n    .review-review {\n      font-weight: 500;\n      margin-bottom: 1.667rem;\n      @media (min-resolution: 2dppx) and (min-width: $tablet) {\n        margin-bottom: 1.8337rem;\n      }\n      @media (max-width: 767px) {\n        margin-bottom: 4.583rem;\n        padding-bottom: 0.583rem;\n      }\n    }\n\n    .review-name {\n      font-weight: 700;\n      margin-bottom: 0rem;\n      @media (min-resolution: 2dppx) and (min-width: $tablet) {\n        margin-bottom: 0rem;\n      }\n      @media (max-width: 767px) {\n        position: absolute;\n        bottom: 0;\n        left: 50%;\n        transform: translateX(-50%);\n        margin-bottom: 3rem;\n      }\n    }\n    .review-quotation-mark {\n      height: 2rem;\n      margin-bottom: 0.667rem;\n      @media (min-resolution: 2dppx) and (min-width: $tablet) {\n        height: 2.2rem;\n        margin-bottom: 0.7337rem;\n      }\n      @media (max-width: 767px) {\n        display: none;\n      }\n    }\n\n    .dots-container {\n      display: flex;\n      justify-content: end;\n      margin-top: 0.333rem;\n      @media (min-resolution: 2dppx) and (min-width: $tablet) {\n        margin-top: 0.3663rem;\n      }\n      @media (max-width: 767px) {\n        justify-content: center;\n        margin-top: 1rem;\n        margin-bottom: 1.333rem;\n        position: absolute;\n        bottom: 0;\n        left: 50%;\n        transform: translateX(-50%);\n      }\n    }\n\n    .dot {\n      height: 0.667rem;\n      width: 0.667rem;\n      background-color: rgba(232, 232, 232, 0.91);\n      border-radius: 50%;\n      margin: 0 0.167rem;\n      transition: background-color 0.3s ease;\n      @media (min-resolution: 2dppx) and (min-width: $tablet) {\n        height: 0.7337rem;\n        width: 0.7337rem;\n        margin: 0 0.1837rem;\n      }\n    }\n\n    .dot.active {\n      background-color: $magenta;\n    }\n  }\n\n  .new-registration-card-container {\n    @media (min-width: 767px) and (max-width: 1023px) {\n      grid-row: 2;\n      grid-column: 2;\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      height: 100%;\n    }\n    @media (max-width: 767px) {\n      width: 100%;\n      z-index: 3;\n      position: absolute;\n      top: 51%;\n    }\n    @media (max-width: 344px) and (min-height: 882px) {\n      top: 47%;\n    }\n    .card {\n      width: 42.917rem;\n      height: auto;\n      padding: 3.667rem 2.667rem 2rem 2.667rem;\n      border-radius: 0;\n      @media (min-width: 767px) and (max-width: 1023px) {\n        width: unset;\n        height: 100%;\n      }\n      @media (min-resolution: 2dppx) and (min-width: $laptop) {\n        width: 47.2087rem;\n        padding: 4.0337rem 2.9337rem 2.2rem 2.9337rem;\n      }\n      @media (max-width: 767px) {\n        width: 100%;\n        min-width: 32.5rem;\n        padding: 3.2rem 2.133rem 3.2rem 2.133rem;\n      }\n      h2 {\n        margin-top: 0;\n        font-size: 1.667rem;\n        color: #515151;\n        margin-bottom: 3.333rem !important;\n        @media (min-resolution: 2dppx) and (min-width: $tablet) {\n          font-size: 1.8337rem;\n          margin-bottom: 3.6663rem !important;\n        }\n        @media (max-width: 767px) {\n          margin-bottom: 3.2rem !important;\n        }\n      }\n      .referral-container {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        margin-bottom: 3.333rem !important;\n        @media (min-resolution: 2dppx) and (min-width: $tablet) {\n          margin-bottom: 3.6663rem !important;\n        }\n        @media (max-width: 767px) {\n          margin-bottom: 3.2rem !important;\n        }\n      }\n      .referral-text {\n        display: flex;\n        flex-direction: column;\n        align-items: flex-start;\n        font-size: 1.25rem;\n        font-weight: 500;\n        color: rgba(81, 81, 81, 1);\n        margin-right: 1.333rem;\n        @media (min-resolution: 2dppx) and (min-width: $tablet) {\n          font-size: 1.375rem;\n          margin-right: 1.4663rem;\n        }\n      }\n      .referral-text p {\n        margin: 0;\n      }\n      .referral-code {\n        text-align: center;\n        margin-top: 3.333rem;\n        margin-bottom: 1.333rem;\n        color: #8e8e8e;\n        font-size: 1.167rem;\n        @media (min-resolution: 2dppx) and (min-width: $tablet) {\n          font-size: 1.2837rem;\n          margin-top: 3.6663rem;\n          margin-bottom: 1.4663rem;\n        }\n      }\n      .new-registration-form-block {\n        margin-bottom: 1rem;\n        @media (min-resolution: 2dppx) and (min-width: $tablet) {\n          margin-bottom: 1.1rem;\n        }\n        .new-registration-input-row {\n          @media (min-width: 767px) and (max-width: 1023px) {\n            display: flex;\n            gap: 2rem;\n            justify-content: space-between;\n          }\n          .form-group {\n            @media (min-width: 767px) and (max-width: 1023px) {\n              flex: 1;\n            }\n          }\n        }\n      }\n      .form-group {\n        margin-bottom: 1.333rem;\n        @media (min-resolution: 2dppx) and (min-width: $tablet) {\n          margin-bottom: 1.4663rem;\n        }\n      }\n      .form-group:has(.new-registration-referral) {\n        margin-bottom: 0 !important;\n      }\n      .new-registration-referral {\n        width: 9.417rem;\n        height: 3.333rem;\n        font-size: 1.25rem;\n        font-weight: 500;\n        color: rgba(136, 136, 136, 0.5);\n        text-align: center;\n        border: 1px solid rgba(136, 136, 136, 0.5) !important;\n        border-radius: 0;\n        margin-bottom: 0 !important;\n        @media (min-resolution: 2dppx) and (min-width: $tablet) {\n          width: 10.3587rem;\n          height: 3.6663rem;\n          font-size: 1.375rem;\n          border: 1.1px solid rgba(136, 136, 136, 0.5) !important;\n        }\n      }\n      .new-registration-field {\n        padding-left: 0rem;\n        padding-bottom: 1.667rem;\n        padding-top: 0.667rem;\n        font-size: 1.333rem;\n        font-weight: 500;\n        color: #8e8e8e;\n        border-bottom: 0.083rem solid #888888 !important;\n        @media (min-resolution: 2dppx) and (min-width: $tablet) {\n          font-size: 1.4663rem;\n          padding-bottom: 1.8337rem;\n          padding-top: 0.7337rem;\n        }\n      }\n    }\n  }\n}\n\n.new-registration-button {\n  margin-top: 2rem !important;\n  font-size: 1.333rem !important;\n  font-weight: 500 !important;\n  padding-top: 1rem !important;\n  padding-bottom: 1rem !important;\n  display: block;\n  width: 100%;\n  @media (min-resolution: 2dppx) and (min-width: $tablet) {\n    font-size: 1.4663rem !important;\n    margin-top: 2.2rem !important;\n    padding-top: 1.1rem !important;\n    padding-bottom: 1.1rem !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
